<template>
    <el-table
        v-loading="isLoading"
        :data="data"
        class="row-click ah-el-data-table salary-page-fixed-table"
        show-summary
        :summary-method="getSummaries"
        border
        @row-click="$event => $emit('row-click', $event)"
    >
        <el-table-column prop="month" label="所屬月份" sortable width="130">
            <template slot-scope="scope">
                <span class="strong"> {{ scope.row.year }} 年 {{ scope.row.month }} 月 </span>
            </template>
        </el-table-column>
        <el-table-column prop="headcount" label="領薪人數" align="right" width="80" type="headcount">
            <template slot-scope="scope">
                <Money :v="scope.row.headcount" />
            </template>
        </el-table-column>
        <el-table-column prop="totaL_AMT" label="領固定薪資" sortable align="right" min-width="130">
            <template slot-scope="scope">
                <div class="primary-number"><Money :v="scope.row.totaL_AMT" /></div>
            </template>
        </el-table-column>
        <el-table-column prop="averageSalary" label="平均薪資" sortable align="right" min-width="130">
            <template slot-scope="scope">
                <Money :v="scope.row.averageSalary" round />
            </template>
        </el-table-column>
        <el-table-column prop="withholdingTax" label="代扣稅款" sortable align="right" width="130">
            <template slot-scope="scope">
                <div class="primary-number">
                    <Money :v="scope.row.withholdingTax" />
                </div>
                <div class="sub-numbers">
                    <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                        <span>
                            {{ scope.row.withholdingTaxPaymentDate | dateFormater("YYYY-MM-dd") }}
                        </span>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="withholdingLabor" label="代扣勞保" sortable align="right" width="130">
            <template slot-scope="scope">
                <div class="primary-number">
                    <Money :v="scope.row.withholdingLabor" />
                </div>
                <div class="sub-numbers">
                    <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                        <span>
                            {{ scope.row.withholdingLaborPaymentDate | dateFormater("YYYY-MM-dd") }}
                        </span>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="withholdingHealth" label="代扣健保" sortable align="right" width="130">
            <template slot-scope="scope">
                <div class="primary-number">
                    <Money :v="scope.row.withholdingHealth" />
                </div>
                <div class="sub-numbers">
                    <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                        <div>
                            {{ scope.row.withholdingHealthPaymentDate | dateFormater("YYYY-MM-dd") }}
                        </div>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="withholdingOther" label="其他代扣" sortable align="right" width="130">
            <template slot-scope="scope">
                <div class="primary-number">
                    <Money :v="scope.row.withholdingOther" />
                </div>
                <div class="sub-numbers">
                    <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                        <span>
                            {{ scope.row.withholdingOtherPaymentDate | dateFormater("YYYY-MM-dd") }}
                        </span>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="amt" label="實付薪資" sortable align="right" min-width="130">
            <template slot-scope="scope">
                <div class="primary-number"><Money :v="scope.row.amt" /></div>
            </template>
            <template slot-scope="scope">
                <div class="primary-number">
                    <Money :v="scope.row.amt" />
                </div>
                <div class="sub-numbers">
                    <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                        <span>{{ scope.row.paY_DAT | dateFormater("YYYY-MM-dd") }}</span>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <!-- <el-table-column
            prop="amt"
            label="付款日期"
            sortable
            align="right"
            width="120"
            type="date"
        >
            <template slot-scope="scope">
                <span style="font-weight: bold">
                    {{ scope.row.paY_DAT | dateFormater("YYYY-MM-dd") }}
                </span>
            </template>
        </el-table-column> -->
        <!-- <el-table-column
            prop="averageSalary"
            label="平均薪資"
            sortable
            align="right"
            min-width="130"
        >
            <template slot-scope="scope">
                <Money :v="scope.row.averageSalary" round />
            </template>
        </el-table-column> -->
    </el-table>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        isLoading: Boolean,
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '總計';
                    return;
                }
                if (column.type === 'date' || column.type === 'headcount') {
                    // 付款日期、人數
                    return;
                }

                const values = data.map((item) => Number(item[column.property]));
                if (!values.every((value) => Number.isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!Number.isNaN(value)) {
                            return prev + curr;
                        }
                        return prev;
                    }, 0);
                    sums[index] += '';
                } else {
                    sums[index] = 'N/A';
                }

                if (index !== 0) {
                    if (!Number.isNaN(sums[index])) {
                        sums[index] = Number.parseInt(sums[index], 10).toLocaleString('en-US');
                    }
                }
            });

            return sums;
        },
    },
};
</script>
<style lang="scss">
.salary-page-fixed-table {
    .el-table__header-wrapper tbody td,
    .el-table__footer-wrapper tbody td {
        // background-color: #fff;
        // border-top: 1px solid #ccc;
        font-weight: bold;
    }
}
</style>
